import { V3Record } from 'data/helpers/V3Record.js'

export const ExperienceGuidePage = V3Record('experienceGuidePage', {
  experienceId: null,
  createdAt: null,
  updatedAt: null,
  content: null,
  title: null,
  position: null,
  isLive: false,
  isHeader: false,
  experienceGuidePageId: null // present if nested
}, {
  writeable: [
    'experienceId',
    'content',
    'title',
    'position',
    'isLive',
    'isHeader',
    'experienceGuidePageId'
  ]
})

const _defaultDeserialize = ExperienceGuidePage.deserialize
const _defaultSerialize = ExperienceGuidePage.serialize
ExperienceGuidePage.deserialize = (fromRails) => {
  const gp = _defaultDeserialize(fromRails)

  if (gp.content) {
    return gp.set('content', JSON.parse(gp.content))
  } else {
    return gp
  }
}

ExperienceGuidePage.serialize = (toRails) => {
  const response = _defaultSerialize(toRails).experience_guide_page
  const { content } = response
  delete response.content
  const val = {
    experience_guide_page: Object.assign(
      { ...response },
      content && { content: JSON.stringify(content) }
    )
  }

  return val
}
